<template>
  <div id="app" class="d-flex flex-column h-100">
    <div id='stars'></div>
    <div id='stars2'></div>
    <div id='stars3'></div>

    <cv-header aria-label="Skillrocket header">
      <cv-skip-to-content href="#main-content">
        Skip to content
      </cv-skip-to-content>
      <cv-header-name to="/">
        <img src="@/assets/logo_full.png" />
      </cv-header-name>
      <template v-if="$auth.isAuthenticated">
        <!--
        <cv-header-nav
          aria-label="Skill Rocket Navigation">
          <cv-header-menu-item to="/schulen">Schulen</cv-header-menu-item>
        </cv-header-nav>
        -->
        <template slot="header-global">
          <cv-header-global-action
            aria-label="Search"
            aria-controls="search-panel"
            @click="toggleGlobalAction('search')">
            <Search20 />
          </cv-header-global-action>
          <cv-header-global-action
            aria-label="Settings"
            aria-controls="settings-panel"
            @click="toggleGlobalAction('settings')">
            <Settings20 />
          </cv-header-global-action>
          <cv-header-global-action
            aria-label="User avatar"
            aria-controls="user-panel"
            @click="toggleGlobalAction('user')">
            <UserAvatar20 />
          </cv-header-global-action>
        </template>
        
        <template slot="right-panels">
          <cv-header-panel
            id="item-panel"
            :class="{
              'bx--header-panel--expanded': globalActionActive === 'item',
              'bx--header-panel--hide': globalActionActive !== 'item',
            }">
            <section
              v-if="selectedNode"
              class="panel__container topicDetails">

              <h3>dein persönlicher Fortschritt in diesem Thema...</h3>
              <div style="margin-top: 5px; width: 100%; height: 15px; background-color: #ffffff; padding: 3px; border-radius: 4px; padding: 0">
                <div style="height: 15px; background-color: #4676cf; border-radius: 3px" v-bind:style="{ width: selectedNode.progress + '%' }"></div>
              </div>


              <h1>{{ selectedNode.title }}</h1>
              <p class="abstract">{{ selectedNode.abstract }}</p>

              <section v-if="selectedNode.isChallenge">
                <button class="challengeBtn" v-if="!isStarted" @click="startChallenge">
                  <img src="@/assets/game-boy-advance.png">
                  <span>Start</span>
                </button>

                <section v-if="isStarted">
                  <button class="challengeBtnClicked">
                    <img src="@/assets/game-boy-advance.png">
                    <span>Du machst mit, Super!</span>
                  </button>
                  <p style="margin-top:1rem">Gehe nun zurück zum Lernpfad und arbeite die einzelnen Themen durch. Viel Spass</p>
                </section>
              </section>

              <section v-if="selectedNode.materials" class="materials">
                <hr class="white">
                <h1>Materialien</h1>

                <section class="searchTable">
                  <table>
                    <tr v-for="item in selectedNode.materials" :key="item.id">
                      <td class="tableCell" style="width: 200px"><a v-bind:href="item.url" target="_blank" style="color: white; text-decoration:none">{{ item.label }}</a></td>
                      <td class="tableCell" style="width: 100px">{{ (item.time || 45) + ' Minuten'}}</td>
                      <td class="tableCell" style="width: 40px"><font-awesome-icon icon="link" class="mr-2" /></td>
                    </tr>
                  </table>
                </section>
              </section>

              <section v-if="selectedNode.tasks" class="materials">
                <hr class="white">
                <h1>Aufgaben</h1>
                <section class="searchTable">
                  <table>
                    <tr v-for="item in selectedNode.tasks" :key="item.id">
                      <td class="tableCell" style="width: 100%"><a v-bind:href="item.url" target="_blank" style="color: white; text-decoration:none">{{ item.label }}</a></td>
                    </tr>
                  </table>
                </section>
              </section>

            </section>
          </cv-header-panel>

          <cv-header-panel
            id="search-panel"
            :class="{
              'bx--header-panel--expanded': globalActionActive === 'search',
              'bx--header-panel--hide': globalActionActive !== 'search'
            }" class="right-panels">
            <section class="panel__container">
              <search />
            </section>
          </cv-header-panel>
          <cv-header-panel
            id="settings-panel"
            :class="{
              'bx--header-panel--expanded': globalActionActive === 'settings',
              'bx--header-panel--hide': globalActionActive !== 'settings'
            }">
            <section class="panel__container stretch">
                <cv-tabs class="stretch">
                  <cv-tab height="fill" label="Klassen">
                    <Classes :schoolid="$auth.user.school"></Classes>
                  </cv-tab>
                  <cv-tab height="5" label="Bibliothek">
                    <library :school="$auth.user.school"></library>
                  </cv-tab>
                </cv-tabs>
                <!-- <button :class="classesOrLibrary == 'classes' ? 'active':''" class="toggleButton" @click="classesOrLibrary = 'classes'">Klassen</button>
                <button :class="classesOrLibrary == 'library' ? 'active':''" class="toggleButton" @click="classesOrLibrary = 'library'">Bibliothek</button> -->
              </section>
          </cv-header-panel>

          <cv-header-panel
            id="user-panel"
            :class="{
              'bx--header-panel--expanded': globalActionActive === 'user',
              'bx--header-panel--hide': globalActionActive !== 'user'
            }">
            <section class="panel__container stretch">
              <div class="user_profile">
                <section>
                  <div class="profile-name">{{ $auth.user.name }}</div>
                </section>
                <img
                  :src="$auth.user.picture"
                  alt=""
                  class="nav-user-profile rounded-circle align-end"
                  width="50"
                />
              </div>
              <button
                class="bx--btn bx--btn--danger logoutBtn"
                type="button"
                @click.prevent="logout">
                Log out
              </button>
            </section>
          </cv-header-panel>
        </template>
      </template>
      <template v-else-if="!$auth.isAuthenticated && !$auth.loading">
        <template slot="header-global">
          <cv-header-global-action
            class="bx--btn bx--btn--primary"
            aria-label="Login"
            @click.prevent="login">
            Login
          </cv-header-global-action>
        </template>
      </template>
    </cv-header>
    <main >
      <router-view v-if="$auth.isAuthenticated" name="authenticated" />
      <router-view v-else-if="!$auth.isAuthenticated && !$auth.loading" name="unauthenticated" />
    </main>
  </div>
</template>


<script>
/* eslint-disable */
import { mapState, mapMutations, mapActions } from 'vuex'

import {
  CvTag,
  CvHeader,
  CvSearch,
  CvButton,
  CvHeaderGlobalAction,
  CvHeaderName,
  CvHeaderPanel,
  CvSkipToContent,
  CvSideNav,
  CvDropdown,
  CvDropdownItem,
  CvInlineLoading,
  CvContentSwitcher,
  CvContentSwitcherButton,
  CvHeaderNav,
  CvHeaderMenuItem,
  CvTabs,
  CvTab
} from '@carbon/vue/src'

import Library from './components/Library'
import Classes from './components/Classes'
import Search from './components/Search'

import Drag16 from '@carbon/icons-vue/es/drag--vertical/16'
import User32 from '@carbon/icons-vue/es/user/32'
import Menu20 from '@carbon/icons-vue/es/menu/20'
import Close20 from '@carbon/icons-vue/es/close/20'
import Search20 from '@carbon/icons-vue/es/search/20'
import Login20 from '@carbon/icons-vue/es/login/20'

import TrashCan16 from '@carbon/icons-vue/es/trash-can/16'
import Settings20 from '@carbon/icons-vue/es/settings/20'
import NotificationNew20 from '@carbon/icons-vue/es/notification--new/24'
import UserAvatar20 from '@carbon/icons-vue/es/user--avatar/20'
import AppSwitcher20 from '@carbon/icons-vue/es/app-switcher/20'
import Bookmark20 from '@carbon/icons-vue/es/bookmark/20'
import Document16 from '@carbon/icons-vue/es/document--blank/16'
import Folder16 from '@carbon/icons-vue/es/folder/16'

export default {
  name: 'template-home',
  components: {
    CvTag,
    CvHeader,
    CvSearch,
    CvHeaderPanel,
    CvHeaderName,
    CvHeaderNav,
    CvHeaderMenuItem,
    CvHeaderGlobalAction,
    CvSkipToContent,
    CvDropdown,
    CvDropdownItem,
    User32,
    Drag16,
    Menu20,
    Login20,
    Close20,
    TrashCan16,
    Search20,
    Folder16,
    Document16,
    Bookmark20,
    Settings20,
    NotificationNew20,
    UserAvatar20,
    AppSwitcher20,
    CvSideNav,
    CvInlineLoading,
    CvContentSwitcher,
    CvContentSwitcherButton,
    Notifications: () => import('@/components/Notifications'),
    Library,Classes,CvTabs,CvTab,Search
  },
  data () {
    return {
      globalActionActive: null,
      classesOrLibrary: 'classes',
      isStarted: false
    }
  },
  computed: {
    ...mapState('global', [
      'selectedNode'
    ])
  },
  methods: {
    toggleGlobalAction (value) {
      this.globalActionActive = value
    },
    login() {
      this.$auth.loginWithRedirect();
    },
    logout() {
      this.$auth.logout();
      this.$router.push({ path: "/" });
    },
    startChallenge() {
      this.isStarted = true;
      this.selectedNode.progress = 100;
    }
  },
  watch: {
    selectedNode: {
      immediate: true,
      handler (newValue, oldValue) {
        if (newValue) {
          this.globalActionActive = 'item';
        } else {
          this.globalActionActive = null;
        }
      }
    }
  }
}
</script>

<style lang="scss" >
@import "./styles/global.scss";

.user_profile {
  display: flex;
  flex: 1;
  align-content: flex-start;
}

.user_profile section {
  flex: 1;
}

.stretch {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.toggleButton {
  flex: 1;
  height: 50px;
  margin-right: 2px;
  margin-left: 2px;
  background-color: #262f46;
  border-width: 0;
  font-size: 32px;
  color: azure;
}

.toggleButton.active {
    background-color: #535f7a;
}

.toggleButton:hover {
  cursor: pointer;
  background-color: #535f7a;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.profile-name {
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  font-size: 1.75rem;
}

.align-end {
  align-self: end;
}

.icon-space {
  margin-right: 1rem;
}

.abstract {
  font-size: 1.1rem;
}

hr {
  margin-top: 20px;
  margin-bottom: 20px;
}


li {
  list-style-type: circle;
}

.bx--tabs__nav-link{
  color:azure !important;
}

.cv-tabs__panels{
  height: 100%;
}
.cv-tab{
  height: 100%;
}

.cv-tab.bx--tabs{
  height: auto !important;
}


h1 {
  font-size: 1.5rem !important;
}

a:link {
  color: white !important;
  font-size: 1rem !important;
}

table {
  width: 100%;
  font-size: 1.25rem;
  background-color: rgba(199, 199, 199, 0.1);
}

tr {
  height: 40px !important;
}

.tableCell {
  font-size: 1.25em !important;
  padding: 10px;
  width: 50%;
  display: table-cell;
  vertical-align: middle;
}


tr:hover { 
   background-color: rgba(199, 199, 199, 0.3);
}

.challengeBtn {
  position: relative;
  margin-top: 2rem;
  border: 0;
  width: 100%;
  height: 40px;
  background-color: #fa4d56;
  color: white;
  font-size: 1.25rem !important;
}

.challengeBtn img 
{  
  width: 30px;
  display: inline-block;
  vertical-align: middle;
}

.challengeBtn span
{
    display: inline-block;
    width: 80px;
    font-size: 1.25rem;
    vertical-align: middle;
}

.challengeBtnClicked {
  margin-top: 2rem;
  border: 0;
  width: 100%;
  height: 40px;
  background-color: #4589ff;
  color: white;
  font-size: 1.25rem !important;
}

.challengeBtnClicked img 
{  
  width: 30px;
  display: inline-block;
  vertical-align: middle;
}

.challengeBtnClicked span
{
    display: inline-block;
    width: 200px;
    font-size: 1.15rem;
    vertical-align: middle;
}


</style>